import React from 'react';
import PropTypes from 'prop-types';
import { FDAlert } from '@facet-wealth/design';


const Alert = ({
  status,
  description,
  details,
  title,
  ...rest
}) => {
  if (!title) {
    return null;
  }
  return (
    <FDAlert
      {...rest}
      title={title}
      description={description}
      details={details}
      status={status}
    />
  );
};

Alert.defaultProps = {
  details: undefined,
  description: undefined,
};

Alert.propTypes = {
  description: PropTypes.string,
  status: PropTypes.oneOf(['error', 'warning', 'info', 'success']).isRequired,
  title: PropTypes.string.isRequired,
  details: PropTypes.array,
};

export { Alert };
